import * as React from 'react';
import renderingInServer from '@shared/renderingInServer';

type Props = {
  children: React.ReactNode;
};

export default function ClientSideRenderedOnly({ children }: Props) {
  return renderingInServer() ? null : <>{children}</>;
}
